import styled from 'styled-components'
import { Card } from 'antd'

export const Container = styled(Card)`
  margin: 12px 16px;
`

export const ContainerSegmentControl = styled.div`
  margin-top: 12px;
  padding: 0 12px 12px 12px;
`

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 24px;

  .ant-calendar-picker {
    margin-left: 24px;
  }
`
